import {HeroHeader} from "@/components/HeroHeader.tsx";
import PodcastIframe from "@/components/PodcastIframe.tsx";
import {MetaTags} from "@/hooks/MetaTags.tsx";

const IFRAME_SRC = "https://iframe.iono.fm/chan/5695?layout=modern";

export default function ThoughtsOfTheDay() {
    return (
        <>
            <MetaTags
                title={"Kosmos 94.1 - Gedagte vir die dag"}
                description={"Begin jou dag op die regte noot met ds. Johan Els"}
                url={"/potgooi/gedagte-vir-die-dag"}
            />

            <HeroHeader
                title="Gedagte vir die dag"
                subtitle="Begin jou dag op die regte noot met ds. Johan Els"
                imageAlt="edagte vir die dag"
            />

            <PodcastIframe
                src={IFRAME_SRC}
            />
        </>
    );
}
